import { InitializeDatadog } from '@analytics/datadog';
import { AuthProvider } from '@exploration/auth';
import { ReactElement } from 'react';

const Callback = () => null;

Callback.getLayout = function getLayout(page: ReactElement) {
  return (
    <>
      <InitializeDatadog />
      <AuthProvider>{page}</AuthProvider>
    </>
  );
};

export default Callback;
